import { useState } from "react";

import { TokenGate } from "./auth/TokenGate";
import { DiskLowBanner } from "./components/DiskLowBanner";
import { TabBar, type Tab } from "./components/TabBar";
import { GalleryView } from "./views/GalleryView";
import { UserView } from "./views/UserView";

export default function App() {
  return <TokenGate>{(_label, isAdmin) => <MainApp isAdmin={isAdmin} />}</TokenGate>;
}

function MainApp({ isAdmin }: { isAdmin: boolean }) {
  const [tab, setTab] = useState<Tab>("gallery");
  return (
    <div className="flex h-full flex-col md:flex-col-reverse">
      <main className="flex-1 overflow-hidden pb-16 md:pb-0">
        <DiskLowBanner isAdmin={isAdmin} />
        {tab === "gallery" ? <GalleryView isAdmin={isAdmin} /> : <UserView />}
      </main>
      <TabBar current={tab} onChange={setTab} />
    </div>
  );
}
